import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { LogonService } from '@sabstravtech/obtservices/angular';

import { BaseComponent } from '../../core/components/base_components/base-componet';
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  standalone: false
})
export class PasswordResetComponent extends BaseComponent implements OnInit, AfterViewInit {
  token: string;
  source: string;

  constructor(
    private logonService: LogonService,
    private route: ActivatedRoute,
    title: Title,
    public translator: TranslateService,
    public themeService: ThemeService
  ) {
    super(title, translator);
    this.setTitle(
      this.translator.instant(
        `Password reset ${this.themeService.isLightningEnv ? ' - LightUk' : ''}`
      )
    );
  }

  ngOnInit(): void {
    this.subscribe(this.route.queryParams, (params) => {
      this.token = params['token'];
      this.source = params['source'];
    });
  }

  ngAfterViewInit() {
    this.logonService.openResetPasswordDialog(this.token, this.source);
  }
}
